import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-page-comparatore',
  templateUrl: './landing-page-comparatore.component.html',
  styleUrls: ['./landing-page-comparatore.component.scss']
})

export class LandingPageComparatoreComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/landing-page-comparatore/landing-page-comparatore.component.ts